module.exports = __webpack_public_path__ + "img/sweet-potato-casserole.a814db6f.jpg";